import { render, staticRenderFns } from "./audit-identify.vue?vue&type=template&id=0f2482d0&scoped=true"
import script from "./audit-identify.vue?vue&type=script&lang=js"
export * from "./audit-identify.vue?vue&type=script&lang=js"
import style0 from "./audit-identify.vue?vue&type=style&index=0&id=0f2482d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2482d0",
  null
  
)

export default component.exports